import {BaseDTO} from './_baseDTO.interface';
import {DamageDTO} from './damageDTO.interface';
import {BaseIntDTO} from "./_baseIntDTO.interface";

export interface DamageDetailDTO extends BaseIntDTO {
  damageId: number;
  damage: DamageDTO;
  detailDescription: string;
}
